import { objectRemoveKeys } from "@/services/utils/general";
import { get } from "lodash";

export const parseUserInformation = (info) => {
  const parsedUser = {
    ...info,
    ...get(info, "metadata"),
  };

  return objectRemoveKeys(parsedUser, ["user", "metadata"]);
};
